import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row py-3 pb-0 g-0" }
const _hoisted_2 = { class: "col-12 col-lg-6 px-4 g-0" }
const _hoisted_3 = { class: "col-12 py-2" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "form-group col-12 col-lg-6 pe-lg-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_First_Name_Label",
  for: "referral-first-name"
}, [
  /*#__PURE__*/_createTextVNode(" First Name "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_7 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_8 = { class: "form-group col-4 col-lg-6 pe-lg-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "referral-middle-initial" }, " M.I. ", -1 /* HOISTED */)
const _hoisted_10 = { class: "form-group col-12 col-lg-6 pe-lg-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_Last_Name_Label",
  for: "referral-last-name"
}, [
  /*#__PURE__*/_createTextVNode(" Last Name "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_12 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_13 = {
  key: 0,
  class: "col-12 py-2"
}
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-12 d-flex align-items-center" }
const _hoisted_16 = { class: "me-2 ai-validate-address-btn" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-triangle me-2" }, null, -1 /* HOISTED */)
const _hoisted_18 = {
  key: 1,
  class: "text-success fw-bold"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check-circle" }, null, -1 /* HOISTED */)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, " Address Validated ", -1 /* HOISTED */)
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = {
  key: 1,
  class: "col-12 p-2"
}
const _hoisted_23 = { class: "form-group d-flex fw-bold justify-content-between" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "me-3" }, " Branch Name", -1 /* HOISTED */)
const _hoisted_25 = { class: "mt-2 d-flex flex-column" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "font-size-3xs fw-normal" }, " Select View Branch History to view or modify the branch associated to this client. Select Add Branch to add a new branch and an associated effective date. ", -1 /* HOISTED */)
const _hoisted_27 = { class: "d-flex mt-2" }
const _hoisted_28 = {
  key: 2,
  class: "col-12 py-2"
}
const _hoisted_29 = { class: "form-group row col-12 col-lg-12 pe-lg-2" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_Agency_Branch_Label",
  for: "agency-location-id"
}, [
  /*#__PURE__*/_createTextVNode(" Agency Branch "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Branch", -1 /* HOISTED */)
const _hoisted_32 = ["value"]
const _hoisted_33 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_34 = { class: "col-12 py-2" }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "form-group" }
const _hoisted_37 = { for: "referral-mobile-number" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_39 = {
  key: 1,
  class: "field-invalid"
}
const _hoisted_40 = { class: "d-flex justify-content-end" }
const _hoisted_41 = {
  key: 0,
  class: "me-2 mt-2"
}
const _hoisted_42 = ["onClick"]
const _hoisted_43 = {
  key: 1,
  class: "mr mt-2"
}
const _hoisted_44 = ["onClick"]
const _hoisted_45 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", { for: "referral-email" }, " Email ", -1 /* HOISTED */)
const _hoisted_47 = { class: "col-12 col-lg-6 px-4 g-0" }
const _hoisted_48 = { class: "col-12 py-2" }
const _hoisted_49 = { class: "row" }
const _hoisted_50 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", {
  for: "date-of-birth",
  id: "Referral_Date_Of_Birth_Label"
}, [
  /*#__PURE__*/_createTextVNode(" Date of Birth "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_52 = { class: "input-group date datepickerInput" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_54 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_55 = { class: "me-2 mt-2" }
const _hoisted_56 = { key: 1 }
const _hoisted_57 = { class: "form-group col-12 col-lg-6 pe-lg-2" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_Gender_Label",
  for: "referral-gender"
}, [
  /*#__PURE__*/_createTextVNode("Sex "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Gender", -1 /* HOISTED */)
const _hoisted_60 = ["value"]
const _hoisted_61 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_62 = { class: "form-group col-12 col-lg-6 pe-lg-2" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_Gender_Label",
  for: "referral-gender"
}, " Gender Pronouns ", -1 /* HOISTED */)
const _hoisted_64 = { class: "form-group col-12 col-lg-6 pe-lg-2" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_Medicaid_Label",
  for: "referral-medicaid"
}, " Medicaid Number ", -1 /* HOISTED */)
const _hoisted_66 = { class: "form-group col-4 col-lg-6 pe-lg-2" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_Alternate_Medicaid_Label",
  for: "referral-alternate-medicaid"
}, "Alternate Medicaid Number", -1 /* HOISTED */)
const _hoisted_68 = { class: "form-group col-4 col-lg-6 pe-lg-2" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("label", { for: "referral-social-security-number" }, " Social Security Number ", -1 /* HOISTED */)
const _hoisted_70 = { class: "col-12 py-2" }
const _hoisted_71 = { class: "row" }
const _hoisted_72 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_Payrate_Label",
  for: "referral-payrate"
}, "Pay Rate Municipality ", -1 /* HOISTED */)
const _hoisted_74 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Municipality", -1 /* HOISTED */)
const _hoisted_75 = ["value"]
const _hoisted_76 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_77 = { class: "col-12 py-2" }
const _hoisted_78 = { class: "row" }
const _hoisted_79 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("label", { for: "referral-tags" }, " Tags", -1 /* HOISTED */)
const _hoisted_81 = {
  key: 0,
  class: "col-12 py-2"
}
const _hoisted_82 = { class: "row" }
const _hoisted_83 = { class: "form-group col-12 col-lg-6 pe-lg-2" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_Gender_Label",
  for: "referral-gender"
}, "Do Not Resuscitate ", -1 /* HOISTED */)
const _hoisted_85 = /*#__PURE__*/_createElementVNode("option", { value: false }, "No", -1 /* HOISTED */)
const _hoisted_86 = /*#__PURE__*/_createElementVNode("option", { value: true }, "Yes", -1 /* HOISTED */)
const _hoisted_87 = [
  _hoisted_85,
  _hoisted_86
]
const _hoisted_88 = { class: "form-group col-12 col-lg-6 pe-lg-2" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_Gender_Label",
  for: "referral-gender"
}, "Marital Status ", -1 /* HOISTED */)
const _hoisted_90 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Marital Status", -1 /* HOISTED */)
const _hoisted_91 = ["value"]
const _hoisted_92 = {
  key: 1,
  class: "col-12 py-2"
}
const _hoisted_93 = { class: "row" }
const _hoisted_94 = { class: "form-group col-12 col-lg-6 pe-lg-2" }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_Height",
  for: "referral-height"
}, "Height ", -1 /* HOISTED */)
const _hoisted_96 = { class: "form-group d-flex col-5" }
const _hoisted_97 = /*#__PURE__*/_createElementVNode("option", { value: 0 }, "in", -1 /* HOISTED */)
const _hoisted_98 = /*#__PURE__*/_createElementVNode("option", { value: 1 }, "cm", -1 /* HOISTED */)
const _hoisted_99 = [
  _hoisted_97,
  _hoisted_98
]
const _hoisted_100 = { class: "form-group col-12 col-lg-6 pe-lg-2" }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_Weight",
  for: "referral-weight"
}, "Weight ", -1 /* HOISTED */)
const _hoisted_102 = { class: "form-group d-flex col-5" }
const _hoisted_103 = /*#__PURE__*/_createElementVNode("option", { value: 0 }, "lb", -1 /* HOISTED */)
const _hoisted_104 = /*#__PURE__*/_createElementVNode("option", { value: 1 }, "kg", -1 /* HOISTED */)
const _hoisted_105 = [
  _hoisted_103,
  _hoisted_104
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReferralAddressForm = _resolveComponent("ReferralAddressForm")!
  const _component_PhoneNumber = _resolveComponent("PhoneNumber")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_MultiSelectDropdown = _resolveComponent("MultiSelectDropdown")!
  const _component_TagsInput = _resolveComponent("TagsInput")!
  const _component_FormSection = _resolveComponent("FormSection")!
  const _directive_number_only = _resolveDirective("number-only")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    title: "Demographics",
    "full-height": false,
    "application-id": _ctx.referral.application
  }, {
    content: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _withDirectives(_createElementVNode("input", {
                  id: "Referral_First_Name",
                  name: "referral-first-name",
                  class: _normalizeClass(["form-control", `${!_ctx.v$.referral.firstName.$error ? '' : 'field-invalid'}`]),
                  maxlength: "50",
                  type: "text",
                  placeholder: "Enter First Name",
                  onBlur: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.firstName.$touch && _ctx.v$.referral.firstName.$touch(...args))),
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.referral.firstName) = $event))
                }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
                  [_vModelText, _ctx.referral.firstName]
                ]),
                (_ctx.v$.referral.firstName.$error)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, "First name is required."))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _withDirectives(_createElementVNode("input", {
                  name: "referral-middle-initial",
                  class: "form-control",
                  maxlength: "1",
                  type: "text",
                  placeholder: "Enter M.I.",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.referral.middleName) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.referral.middleName]
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _withDirectives(_createElementVNode("input", {
                  id: "Referral_Last_Name",
                  name: "referral-last-name",
                  class: _normalizeClass(["form-control", `${!_ctx.v$.referral.lastName.$error ? '' : 'field-invalid'}`]),
                  maxlength: "50",
                  placeholder: "Enter Last Name",
                  type: "text",
                  onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.lastName.$touch && _ctx.v$.referral.lastName.$touch(...args))),
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.referral.lastName) = $event))
                }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
                  [_vModelText, _ctx.referral.lastName]
                ]),
                (_ctx.v$.referral.lastName.$error)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Last name is required."))
                  : _createCommentVNode("v-if", true)
              ])
            ])
          ]),
          (_ctx.referral.primaryAddress)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_ReferralAddressForm, {
                    address: _ctx.referral.primaryAddress,
                    "onUpdate:address": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.referral.primaryAddress) = $event)),
                    application: _ctx.referral.application,
                    "account-id": _ctx.referral.accountId,
                    "is-primary-address": true,
                    "provider-id": _ctx.providerId,
                    onUpdateAddressDetails: _ctx.updateAddressDetails,
                    onUpdateAddressCountry: _ctx.updateAddressCountry,
                    onUpdateAddressState: _ctx.updateAddressState,
                    ref: "address"
                  }, null, 8 /* PROPS */, ["address", "application", "account-id", "provider-id", "onUpdateAddressDetails", "onUpdateAddressCountry", "onUpdateAddressState"]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      (!_ctx.referral.primaryAddress.isValidated)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "button fr ai-validate-btn",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.validateAddress()))
                          }, " Validate Patient Primary Address "))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _createElementVNode("div", null, [
                      (!_ctx.referral.primaryAddress.isValidated)
                        ? (_openBlock(), _createElementBlock("h6", {
                            key: 0,
                            class: _normalizeClass(`${
                                            _ctx.referral.primaryAddress.isBypassed ? 'text-warning' : 'text-danger'
                                        } fw-bold`)
                          }, [
                            _hoisted_17,
                            _createElementVNode("span", null, "Address " + _toDisplayString(_ctx.referral.primaryAddress.isBypassed
                                                    ? "Validation Bypassed"
                                                    : "Not Validated"), 1 /* TEXT */)
                          ], 2 /* CLASS */))
                        : (_openBlock(), _createElementBlock("h6", _hoisted_18, _hoisted_21))
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          (_ctx.hasTestAgency && _ctx.referral.application === _ctx.applicationEnum.HomeCare && _ctx.isEdit)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createElementVNode("span", null, _toDisplayString(_ctx.branchName), 1 /* TEXT */)
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary btn-md me-2",
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleViewBranchHistory && _ctx.handleViewBranchHistory(...args)))
                    }, " View Branch History "),
                    (_ctx.canAddBranches)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "btn btn-primary btn-md",
                          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handleAddBranch && _ctx.handleAddBranch(...args)))
                        }, " Add Branch "))
                      : _createCommentVNode("v-if", true)
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _withDirectives(_createElementVNode("select", {
                    id: "Referral_Agency_Branch",
                    name: "agency-location-id",
                    class: _normalizeClass(["form-select", `${!_ctx.v$.referral.agencyLocationId.$error ? '' : 'field-invalid'}`]),
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.referral.agencyLocationId) = $event)),
                    onBlur: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.agencyLocationId.$touch && _ctx.v$.referral.agencyLocationId.$touch(...args)))
                  }, [
                    _hoisted_31,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.branches, (branch) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: branch.id,
                        key: branch.id
                      }, _toDisplayString(branch.name), 9 /* TEXT, PROPS */, _hoisted_32))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 34 /* CLASS, HYDRATE_EVENTS */), [
                    [_vModelSelect, _ctx.referral.agencyLocationId]
                  ]),
                  (_ctx.v$.referral.agencyLocationId.$error)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_33, "Agency Branch is required."))
                    : _createCommentVNode("v-if", true)
                ])
              ])),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.referral.phoneNumbers, (phoneNum, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col-12 col-lg-12 pe-lg-2",
                  key: phoneNum.ordinal
                }, [
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("label", _hoisted_37, [
                      _createTextVNode(_toDisplayString(index == 0
                                                ? "Primary Phone"
                                                : index == 1
                                                  ? "Secondary Phone"
                                                  : "Tertiary Phone") + " ", 1 /* TEXT */),
                      _hoisted_38
                    ]),
                    _withDirectives(_createVNode(_component_PhoneNumber, {
                      "enable-country": true,
                      value: phoneNum.number,
                      "onUpdate:value": ($event: any) => ((phoneNum.number) = $event),
                      extension: phoneNum.extension,
                      "onUpdate:extension": ($event: any) => ((phoneNum.extension) = $event),
                      type: phoneNum.type,
                      "onUpdate:type": ($event: any) => ((phoneNum.type) = $event),
                      country: phoneNum.country,
                      "onUpdate:country": ($event: any) => ((phoneNum.country) = $event),
                      "phone-type-options": _ctx.phoneNumberTypeOptionsConfig,
                      onBlurredInput: ($event: any) => (_ctx.validateNumberTouch[index] = true)
                    }, null, 8 /* PROPS */, ["value", "onUpdate:value", "extension", "onUpdate:extension", "type", "onUpdate:type", "country", "onUpdate:country", "phone-type-options", "onBlurredInput"]), [
                      [_directive_number_only]
                    ]),
                    (_ctx.checkPhoneValidation && !_ctx.validateNumberTouch[index])
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.v$.referral.phoneNumbers.$each.$response.$errors[index]?.number, (error) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: error,
                            class: "field-invalid"
                          }, _toDisplayString(error.$message === "Value is required"
                                                ? "Phone number is required."
                                                : "10 Digit phone is required."), 1 /* TEXT */))
                        }), 128 /* KEYED_FRAGMENT */))
                      : (
                                            _ctx.validateNumberTouch[index] &&
                                            _ctx.v$.referral.phoneNumbers.$each.$message[index].length > 0
                                        )
                        ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(_ctx.v$.referral.phoneNumbers.$each.$message[index] == "Value is required"
                                                ? "Phone number is required."
                                                : "10 Digit phone is required."), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                    _createElementVNode("div", _hoisted_40, [
                      (_ctx.showAddAlternatebtn(index))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                            _createElementVNode("button", {
                              class: "btn btn-xs btn-primary mb-2",
                              onClick: ($event: any) => (_ctx.addAlternateContact(index))
                            }, " Add Alternate Number ", 8 /* PROPS */, _hoisted_42)
                          ]))
                        : _createCommentVNode("v-if", true),
                      (index > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                            _createElementVNode("button", {
                              class: "btn btn-xs btn-danger mb-2",
                              onClick: ($event: any) => (_ctx.removeAlternateContact(index))
                            }, " Remove ", 8 /* PROPS */, _hoisted_44)
                          ]))
                        : _createCommentVNode("v-if", true)
                    ])
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */)),
              _createElementVNode("div", _hoisted_45, [
                _hoisted_46,
                _withDirectives(_createElementVNode("input", {
                  name: "referral-email",
                  class: "form-control",
                  maxlength: "50",
                  type: "text",
                  placeholder: "Seperate mulitple emails with ;",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.referral.emailAddress) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.referral.emailAddress]
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_47, [
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("div", _hoisted_50, [
                _hoisted_51,
                _createVNode(_component_DatePicker, { getDate: _ctx.changeDate }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_52, [
                      _withDirectives(_createElementVNode("input", {
                        id: "Referral_Date_Of_Birth",
                        name: "referralHomeCareDOB",
                        type: "text",
                        class: _normalizeClass(["form-control", `${!_ctx.v$.referral.dob.$error ? '' : 'field-invalid'}`]),
                        placeholder: "MM/DD/YYYY",
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formattedDob) = $event)),
                        autocomplete: "off",
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.resetIsNoConflictValue())),
                        onBlur: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.dob.$touch && _ctx.v$.referral.dob.$touch(...args))),
                        "date-format-only": ""
                      }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
                        [_vModelText, _ctx.formattedDob]
                      ]),
                      _hoisted_53
                    ])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["getDate"]),
                (_ctx.v$.referral.dob.$error)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_54, "Date Of Birth is required."))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_55, [
                  (!_ctx.hasNoConflict)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-xs btn-primary mb-2",
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.checkClientConflict()))
                      }, " Check For Client Conflict "))
                    : _createCommentVNode("v-if", true),
                  (_ctx.hasNoConflict)
                    ? (_openBlock(), _createElementBlock("text", _hoisted_56, "There is no conflict!"))
                    : _createCommentVNode("v-if", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_57, [
                _hoisted_58,
                _withDirectives(_createElementVNode("select", {
                  id: "Referral_Gender",
                  class: _normalizeClass(["form-select", `${!_ctx.v$.referral.gender.$error ? '' : 'field-invalid'}`]),
                  name: "referral-gender",
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.referral.gender) = $event)),
                  onBlur: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.gender.$touch && _ctx.v$.referral.gender.$touch(...args)))
                }, [
                  _hoisted_59,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enumToMap(_ctx.GendersEnum), ([key, value]) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: value.value,
                      key: key
                    }, _toDisplayString(value.name), 9 /* TEXT, PROPS */, _hoisted_60))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 34 /* CLASS, HYDRATE_EVENTS */), [
                  [_vModelSelect, _ctx.referral.gender]
                ]),
                (_ctx.v$.referral.gender.$error)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_61, "Gender is required."))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_62, [
                _hoisted_63,
                _createVNode(_component_MultiSelectDropdown, {
                  options: _ctx.genderPronounOptions,
                  "selected-items": _ctx.referral.genderPronounsArray,
                  onSelectedItemsUpdated: _ctx.selectedItemsUpdated
                }, null, 8 /* PROPS */, ["options", "selected-items", "onSelectedItemsUpdated"])
              ]),
              _createElementVNode("div", _hoisted_64, [
                _hoisted_65,
                _withDirectives(_createElementVNode("input", {
                  id: "Referral_Medicaid",
                  name: "referral-medicaid",
                  class: "form-control",
                  maxlength: "50",
                  type: "text",
                  placeholder: "Enter Medicaid Number",
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.referral.medicaidNumber) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.referral.medicaidNumber]
                ])
              ]),
              _createElementVNode("div", _hoisted_66, [
                _hoisted_67,
                _withDirectives(_createElementVNode("input", {
                  id: "Referral_Alternate_Medicaid",
                  name: "referral-alternate-medicaid",
                  class: "form-control",
                  maxlength: "50",
                  type: "text",
                  placeholder: "Enter Alternate Medicaid Number",
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.referral.alternateMedicaidNumber) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.referral.alternateMedicaidNumber]
                ])
              ]),
              _createElementVNode("div", _hoisted_68, [
                _hoisted_69,
                _withDirectives(_createElementVNode("input", {
                  name: "referral-social-security-number",
                  maxlength: "9",
                  class: "form-control",
                  type: "text",
                  placeholder: "Enter SSN",
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.referral.ssn) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.referral.ssn],
                  [_directive_number_only]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_70, [
            _createElementVNode("div", _hoisted_71, [
              _createElementVNode("div", _hoisted_72, [
                _hoisted_73,
                _withDirectives(_createElementVNode("select", {
                  id: "Referral_PayRates",
                  class: "form-select",
                  name: "referral-payrates",
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.referral.payRateMunicipalityId) = $event))
                }, [
                  _hoisted_74,
                  (_ctx.muncipalityPayRates[_ctx.referral.agencyLocationId])
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.muncipalityPayRates[_ctx.referral.agencyLocationId], (payRate) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: payRate.Id,
                          key: payRate
                        }, _toDisplayString(payRate.Name) + " " + _toDisplayString(payRate.Code ? `(${payRate.Code})` : ""), 9 /* TEXT, PROPS */, _hoisted_75))
                      }), 128 /* KEYED_FRAGMENT */))
                    : _createCommentVNode("v-if", true)
                ], 512 /* NEED_PATCH */), [
                  [_vModelSelect, _ctx.referral.payRateMunicipalityId]
                ]),
                (
                                        _ctx.referral.agencyLocationId &&
                                        !_ctx.muncipalityPayRates[_ctx.referral.agencyLocationId]?.length
                                    )
                  ? (_openBlock(), _createElementBlock("p", _hoisted_76, " No pay rate municipalities have been added for this referral's location. If required, please contact your agency administrator to configure pay rate municipalities for Addison in Company Setup. "))
                  : _createCommentVNode("v-if", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_77, [
            _createElementVNode("div", _hoisted_78, [
              _createElementVNode("div", _hoisted_79, [
                _hoisted_80,
                _createVNode(_component_TagsInput, {
                  data: _ctx.tags,
                  tags: _ctx.selectedTags,
                  placeholder: "Select Tags",
                  "aria-autocomplete": "off",
                  "open-on-focus": true,
                  onUpdateTags: _ctx.updateTags
                }, null, 8 /* PROPS */, ["data", "tags", "onUpdateTags"])
              ])
            ])
          ]),
          (!_ctx.referral.isNonMedical)
            ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                _createElementVNode("div", _hoisted_82, [
                  _createElementVNode("div", _hoisted_83, [
                    _hoisted_84,
                    _withDirectives(_createElementVNode("select", {
                      id: "Referral_PayRates",
                      class: "form-select",
                      name: "referral-payrates",
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.referral.isDNR) = $event))
                    }, _hoisted_87, 512 /* NEED_PATCH */), [
                      [_vModelSelect, _ctx.referral.isDNR]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_88, [
                    _hoisted_89,
                    _withDirectives(_createElementVNode("select", {
                      id: "Referral_PayRates",
                      class: "form-select",
                      name: "referral-payrates",
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.referral.maritalStatus) = $event))
                    }, [
                      _hoisted_90,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enumToMap(_ctx.MaritalStatusesEnum), ([key, value]) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: value.value,
                          key: key
                        }, _toDisplayString(value.name), 9 /* TEXT, PROPS */, _hoisted_91))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 512 /* NEED_PATCH */), [
                      [_vModelSelect, _ctx.referral.maritalStatus]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          (!_ctx.referral.isNonMedical)
            ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                _createElementVNode("div", _hoisted_93, [
                  _createElementVNode("div", _hoisted_94, [
                    _hoisted_95,
                    _createElementVNode("div", _hoisted_96, [
                      _withDirectives(_createElementVNode("input", {
                        name: "referral-social-security-number",
                        maxlength: "3",
                        class: "form-control col-lg-6",
                        type: "text",
                        placeholder: "Enter Height",
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.referral.height) = $event)),
                        "number-only": ""
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelText, _ctx.referral.height]
                      ]),
                      _withDirectives(_createElementVNode("select", {
                        id: "Referral_PayRates",
                        class: "form-select col-12 col-lg-5 col-md-6 px-2",
                        name: "referral-payrates",
                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.referral.heightMetric) = $event))
                      }, _hoisted_99, 512 /* NEED_PATCH */), [
                        [_vModelSelect, _ctx.referral.heightMetric]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_100, [
                    _hoisted_101,
                    _createElementVNode("div", _hoisted_102, [
                      _withDirectives(_createElementVNode("input", {
                        name: "referral-social-security-number",
                        maxlength: "3",
                        class: "form-control col-lg-6",
                        type: "text",
                        placeholder: "Enter Weight",
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.referral.weight) = $event))
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelText, _ctx.referral.weight],
                        [_directive_number_only]
                      ]),
                      _withDirectives(_createElementVNode("select", {
                        id: "Referral_PayRates",
                        class: "form-select col-12 col-lg-5 col-md-6 px-2",
                        name: "referral-payrates",
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.referral.weightMetric) = $event))
                      }, _hoisted_105, 512 /* NEED_PATCH */), [
                        [_vModelSelect, _ctx.referral.weightMetric]
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["application-id"]))
}